import type { Environment } from '@openeducation/oe-it-services';

import KeepAliveDao from './dao/keep-alive.dao';

export abstract class KeepAliveService {
  static async getServerTime(env: Environment) {
    return KeepAliveDao.getServerTime(env);
  }

  static async postAlive(
    env: Environment,
    teacherId?: number,
    loginUuid?: string | null
  ) {
    if (!loginUuid || !teacherId) {
      throw new Error('Missing loginUuid or teacherId.');
    }

    return KeepAliveDao.postAlive(env, teacherId, loginUuid);
  }
}
